import urls from "../../constants/api-endpoints";
import helpers from "../../utils/helpers";
import LoginComponent from "../LoginComponent";
import Axios from "../../utils/axios";
import { MixPanelConstants } from "../../constants/MixPanelEvents";
import { MixpanelTracking } from "../../MixPanel";
import accessToken from "../../utils/access-token";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { setUserDetails } from "../../store/AuthSlice";
import { setSnackBar } from "../../store/ToastSlice";

function AdminHome() {
    const dispatch = useDispatch();
    const router = useRouter()

    const handleLogin = (values : any, resetForm : any, setButtonLoader : any) => {
        const endPoint = helpers.getAPIEndpoint(urls.staffLogin);
        const mixPanelData = {
            action : MixPanelConstants.LOGGED_IN,
			actionType : MixPanelConstants.STANDARD,
		}

        setButtonLoader(true);

		const successHandler = (response : any) => {

			const userDetails : any = helpers.decodeToken(response.data.access);
			
			MixpanelTracking.getInstance().identifyUser(userDetails.email);
			MixpanelTracking.getInstance().authFinished({
				...mixPanelData,
				status : MixPanelConstants.SUCCESS
			});

			setButtonLoader(false);
			if (response.status === 200) {
				accessToken.setCredentials(
					response.data.access,
					response.data.refresh,
					response.data.name
				);
				dispatch(setUserDetails({
					isLoggedIn: true,
					name: response.data.name
				}));
				router.push('/support/chat')
				dispatch(setSnackBar(
                    {
                        color : 'success',
                        message : 'You have successfully signed in!'
                    }
                ));
                resetForm();
			}
		}

		const errorHandler = (error : any) => {
			console.log(error.response.data);
			setButtonLoader(false);
			let message = ''
			try {
				message = error.response.data.message[0];
			}
			catch {
				message = error.response.data.detail;
			}
			dispatch(setSnackBar(
                {
                    color : 'error',
                    message : message
                }
            ));

			MixpanelTracking.getInstance().authFinished({
				...mixPanelData,
				status : MixPanelConstants.FAILED
			})
		}

		Axios.requestPOST(
			endPoint,
			values,
			{},
			successHandler,
			errorHandler
		)
    }

    return (
        <LoginComponent 
            portalHeading = "Admin Portal"
            onLogin = {handleLogin}
        />
    )
}

export default AdminHome